import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import SecureVidstackPlayer from './securevidstack'; // Your player component

const ProductVideoGallery = ({ product }) => {
  // 1. State to track which video is currently playing
  const [activeVideo, setActiveVideo] = useState(null);

  // 2. Set the first video as active when product loads
  useEffect(() => {
    if (product?.videos?.length > 0) {
      setActiveVideo(product.videos[0]);
    }
  }, [product]);

  if (!activeVideo) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      
      {/* --- TOP SECTION: MAIN PLAYER --- */}
      <Box className="videoplayer" sx={{ width: "100%", height: "auto" }}>
        {/* key={activeVideo.video_guid} is CRITICAL. 
            It forces React to destroy and recreate the player when the video changes,
            ensuring the new video loads immediately.
        */}
        <SecureVidstackPlayer 
            key={activeVideo.video_guid} 
            videoGuid={activeVideo.video_guid} 
            aspectRatio="16/9"
        />
        
        {/* Optional: Show Title of active video */}
        <Typography variant="h6" sx={{ mt: 1 }}>
            {activeVideo.title}
        </Typography>
      </Box>

      {/* --- BOTTOM SECTION: CLICKABLE LIST --- */}
      <Box sx={{ display: "flex", flexDirection: "row", gap: "10px", overflowX: "auto", pb: 1 }}>
        {product.videos?.map((video, index) => {
           // Check if this is the currently playing video
           const isActive = activeVideo.video_guid === video.video_guid;

           return (
            <Box 
                key={index} 
                onClick={() => setActiveVideo(video)} // <--- CLICK TO PLAY
                sx={{ 
                    width: {xs:"100%",sm:"150px",md:"150px"},
                    height: "150px", 
                    flexShrink: 0, // Prevents squishing
                    cursor: "pointer",
                    border: isActive ? "3px solid #1099F4" : "1px solid #DBE3F0", // Highlight active
                    borderRadius: "10px",
                    overflow: "scroll",
                    position: "relative",
                    transition: "all 0.2s ease",
                    "&:hover": { borderColor: "#1099F4", opacity: 0.9 }
                }}
            >
                {/* PERFORMANCE TIP: 
                   Instead of loading a full <Player> here, we show the Thumbnail Image.
                   This is much faster than loading 5+ HLS streams simultaneously.
                */}
                <img 
                    src={video.thumbnail_url || video.thumbnail} 
                    alt={video.title}
                    style={{ 
                        width: "100%", 
                        height: "100%", 
                        objectFit: "cover" 
                    }} 
                />

                {/* Play Icon Overlay */}
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "rgba(0,0,0,0.6)",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M8 5v14l11-7z" />
                    </svg>
                </Box>
            </Box>
           );
        })}
      </Box>

    </Box>
  );
};

export default ProductVideoGallery;